exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app--2KY2jOJnYCpIlI1HDexNti{width:100%}.app-hd--kLixQGyWTI5DOsHnNfNQZ{position:fixed;top:0;left:0;z-index:2;width:100%;display:none}.app-bd--318jx1ofgW6Idxxea8kzmY{position:relative;z-index:1}.app-content--TKmUo5dV-seKrIqdGrdKb{width:100%;margin:0 auto}.h5modal .ant-modal-confirm-btns{text-align:center;width:100%}\n", ""]);

// Exports
exports.locals = {
	"app": "app--2KY2jOJnYCpIlI1HDexNti",
	"app-hd": "app-hd--kLixQGyWTI5DOsHnNfNQZ",
	"app-bd": "app-bd--318jx1ofgW6Idxxea8kzmY",
	"app-content": "app-content--TKmUo5dV-seKrIqdGrdKb"
};